import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function CircleIconFilled({
  className,
  fill,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 15}
      viewBoxDimensions="0 0 14 15"
      width={width ?? 14}
    >
      <circle cx="7" cy="7.5" fill={fill} r="7" />
    </SimpleIcon>
  );
}
